
export const API_CONFIG = {
  BASE_URL: import.meta.env.PROD ? '' : 'http://localhost:8788',
  ENDPOINTS: {
    MODULES: '/api/modules',
    LOGIN: '/api/login',
    CONTENT: '/api/content',
    UPLOAD: '/api/upload',
    MEDIA: '/api/media',
  }
};

export const getApiUrl = (endpoint: string) => `${API_CONFIG.BASE_URL}${endpoint}`;
